/* ============
 * shippingProvider Module State
 * ============
 */

export default {
  all: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentShippingProvider: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/shippingProvider/state.js